<template>
  <v-layout>
    <v-col class="custom-content-container pt-0" cols="12" :md="12" :sm="12">
      <v-layout class="d-block">
        <v-row>
          <v-col class="iv-custom-field" cols="12" md="12" sm="12">
            <perfect-scrollbar
              :options="{ suppressScrollX: true }"
              class="scroll"
              style="max-height: calc(100vh - 172px); position: relative"
            >
              <v-container fluid>
                <v-row class="mb-3">
                  <v-col class="pt-1 my-auto" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500 required mt-0"
                      for="status"
                      >Status</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <v-autocomplete
                      hide-details
                      v-model.trim="detail.status"
                      :items="statusList"
                      :rules="[validateRules.required(detail.status, 'status')]"
                      dense
                      flat
                      filled
                      placeholder="Status"
                      item-color="cyan"
                      color="cyan"
                      solo
                      item-value="value"
                      item-text="text"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-title
                            v-html="'No Status(s) Found.'"
                          ></v-list-item-title>
                        </v-list-item>
                      </template>
                      <template v-slot:selection="{ item }">
                        <v-list-item-action class="mx-0 my-0 py-0">
                          <v-chip
                            style="height: 10px; width: 10px; padding: 0"
                            :color="item.color"
                          >
                          </v-chip>
                        </v-list-item-action>
                        <v-list-item-content class="py-0">
                          <v-list-item-title
                            class="text-capitalize font-weight-500 font-size-16"
                            >{{ item.text }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </template>
                      <template v-slot:item="{ item }">
                        <v-list-item-action class="mr-0">
                          <v-chip
                            style="height: 16px; width: 16px; padding: 0"
                            :color="item.color"
                          >
                          </v-chip>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title
                            class="text-capitalize font-weight-500 font-size-16"
                            >{{ item.text }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col class="pt-1 text-right my-auto" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500 required"
                      for="source"
                      >Source</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <v-autocomplete
                      hide-details
                      v-model.trim="detail.source"
                      :items="sourceList"
                      :rules="[validateRules.required(detail.source, 'source')]"
                      dense
                      flat
                      filled
                      placeholder="Source"
                      item-color="cyan"
                      color="cyan"
                      solo
                      item-value="value"
                      item-text="text"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-title
                            v-html="'No Source(s) Found.'"
                          ></v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>

                <v-row class="mb-3">
                  <v-col class="pt-1 my-auto" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500 mt-0"
                      for="opportunity"
                      >Opportunity</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <v-radio-group v-model="detail.opportunity" row>
                      <v-radio
                        label="High Chance"
                        value="High Chance"
                      ></v-radio>
                      <v-radio label="50 50" value="50 50"></v-radio>
                      <v-radio label="Low Chance" value="Low Chance"></v-radio>
                      <v-radio label="None" value="None"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col class="pt-1 text-right my-auto" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500 required"
                      for="product_type"
                      >Product Type</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <v-autocomplete
                      hide-details
                      v-model.trim="detail.product_type"
                      :items="productTypeList"
                      dense
                      flat
                      filled
                      placeholder="Product Type"
                      item-color="cyan"
                      append-outer-icon="mdi-cog"
                      v-on:click:append-outer="openProductTypeDialog"
                      color="cyan"
                      solo
                      item-value="value"
                      item-text="text"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-title
                            v-html="'No Product Type(s) Found.'"
                          ></v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>

                <v-row class="mb-3">
                  <v-col class="pt-1 my-auto" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500 required mt-0"
                      for="assign_to"
                      >Assign To</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <v-autocomplete
                      dense
                      color="cyan"
                      filled
                      :items="userList"
                      :disabled="pageLoading"
                      :readonly="currentUser.role == 5"
                      :loading="pageLoading"
                      v-model.trim="detail.assign_to"
                      :rules="[
                        validateRules.required(detail.assign_to, 'Assign To'),
                      ]"
                      placeholder="Assign To"
                      solo
                      flat
                      item-color="cyan"
                      item-text="display_name"
                      item-value="id"
                      hide-details
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="'No User Found.'"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col class="pt-1 text-right my-auto" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500 required"
                      for="uen"
                      >Amount</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <v-text-field
                      dense
                      filled
                      color="cyan"
                      placeholder="Amount"
                      solo
                      flat
                      class="width-100"
                      type="number"
                      min="0"
                      :max="9999999999.99"
                      hide-spin-buttons
                      v-model.trim.number.lazy="detail.amount"
                      :rules="[
                        validateRules.required(detail.amount, 'Amount'),
                        validateRules.maxLength(detail.amount, 'Amount', 11),
                      ]"
                      v-on:keypress="limitDecimal($event, detail.amount)"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="mb-3">
                  <v-col class="pt-1 my-auto" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500 mt-0 required"
                      for="lead_name"
                      >Name</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <v-text-field
                      dense
                      filled
                      color="cyan"
                      placeholder="Name"
                      solo
                      flat
                      class="width-100"
                      :rules="[
                        validateRules.required(detail.lead_name, 'Lead Name'),
                        validateRules.maxLength(
                          detail.lead_name,
                          'Lead Name',
                          100
                        ),
                      ]"
                      v-model.trim="detail.lead_name"
                    ></v-text-field>
                  </v-col>
                  <v-col class="pt-1 text-right my-auto" md="2" sm="12">
                    <label class="font-size-16 font-weight-500" for="lead_date"
                      >Lead Date</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <DatePicker
                      solo
                      flat
                      :mandatory="false"
                      :nullable="true"
                      placeholder="Lead Date"
                      v-model="detail.lead_date"
                    ></DatePicker>
                  </v-col>
                </v-row>

                <v-row class="mb-3">
                  <v-col class="pt-1 my-auto" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500 mt-0"
                      for="company_name"
                      >Company Name</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <v-text-field
                      dense
                      filled
                      color="cyan"
                      placeholder="Company Name"
                      solo
                      flat
                      class="width-100"
                      v-model.trim="detail.company_name"
                      :rules="[
                        validateRules.maxLength(
                          detail.company_name,
                          'Company Name',
                          100
                        ),
                      ]"
                    ></v-text-field>
                  </v-col>

                  <v-col class="pt-1 text-right my-auto" md="2" sm="12">
                    <label class="font-size-16 font-weight-500" for="lead_date"
                      >Postal Code</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <v-text-field
                      dense
                      filled
                      color="cyan"
                      placeholder="Postal Code"
                      type="number"
                      solo
                      flat
                      class="width-100"
                      v-model.trim="detail.postal_code"
                      :rules="[
                        validateRules.maxLength(
                          detail.postal_code,
                          'Postal Code',
                          10
                        ),
                      ]"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="mb-3">
                  <v-col class="pt-1 my-auto" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500 mt-0"
                      for="position"
                      >Position</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <v-autocomplete
                      hide-details
                      v-model.trim="detail.position"
                      :items="positionList"
                      dense
                      flat
                      filled
                      placeholder="Position"
                      item-color="cyan"
                      append-outer-icon="mdi-cog"
                      v-on:click:append-outer="openPositionDialog"
                      color="cyan"
                      solo
                      item-value="value"
                      item-text="text"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-title
                            v-html="'No Position(s) Found.'"
                          ></v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col class="pt-1 text-right my-auto" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500"
                      for="address_line_1"
                      >Address Line 1</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <v-text-field
                      dense
                      filled
                      color="cyan"
                      placeholder="Address Line 1"
                      solo
                      flat
                      class="width-100"
                      v-model.trim="detail.address_line_1"
                      :rules="[
                        validateRules.maxLength(
                          detail.address_line_1,
                          'Address Line 1',
                          100
                        ),
                      ]"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="mb-3">
                  <v-col class="pt-1 my-auto" md="2" sm="12">
                    <label class="font-size-16 font-weight-500 mt-0" for="phone"
                      >Phone Number</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <PhoneTextField
                      v-model="detail.phone_number"
                      v-on:blur="isFocusedN = false"
                      v-on:focus="isFocusedN = true"
                    >
                    </PhoneTextField>
                  </v-col>
                  <v-col class="pt-1 text-right my-auto" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500"
                      for="address_line_2"
                      >Address Line 2</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <v-text-field
                      dense
                      filled
                      color="cyan"
                      placeholder="Address Line 2"
                      solo
                      flat
                      class="width-100"
                      v-model.trim="detail.address_line_2"
                      :rules="[
                        validateRules.maxLength(
                          detail.address_line_2,
                          'Address Line 2',
                          100
                        ),
                      ]"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="mb-3">
                  <v-col class="pt-1 my-auto" md="2" sm="12">
                    <label class="font-size-16 font-weight-500 mt-0" for="email"
                      >Email</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <v-text-field
                      dense
                      filled
                      color="cyan"
                      placeholder="Email"
                      solo
                      flat
                      class="width-100"
                      v-model.trim="detail.email"
                      :rules="[
                        validateRules.validEmail(detail.email, 'email'),
                        validateRules.minLength(detail.email, 'email', 2),
                        validateRules.maxLength(detail.email, 'email', 100),
                      ]"
                    ></v-text-field>
                  </v-col>

                  <v-col class="pt-1 text-right my-auto" md="2" sm="12">
                    <label class="font-size-16 font-weight-500" for="unit_no"
                      >Unit Number</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <v-text-field
                      dense
                      filled
                      color="cyan"
                      placeholder="Unit Number"
                      solo
                      flat
                      class="width-100"
                      v-model.trim="detail.unit_no"
                      :rules="[
                        validateRules.maxLength(
                          detail.unit_no,
                          'Unit Number',
                          100
                        ),
                      ]"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="mb-3">
                  <v-col class="pt-1 my-auto" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500 mt-0"
                      for="website"
                      >Website</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <v-text-field
                      dense
                      filled
                      color="cyan"
                      placeholder="Website"
                      solo
                      flat
                      class="width-100"
                      v-model.trim="detail.website"
                      :rules="[
                        validateRules.maxLength(detail.website, 'Website', 100),
                      ]"
                    ></v-text-field>
                  </v-col>

                  <v-col class="pt-1 text-right my-auto" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500 mt-0"
                      for="country"
                      >Country</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <v-autocomplete
                      hide-details
                      v-model.trim="detail.country"
                      :items="countryList"
                      dense
                      flat
                      filled
                      placeholder="Country"
                      item-color="cyan"
                      color="cyan"
                      solo
                      item-value="value"
                      item-text="text"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-title
                            v-html="'No Country(s) Found.'"
                          ></v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <!--  <v-col class="pt-1 text-right d-flex justify-content-end" md="2" sm="12">
                     <v-checkbox
                        v-model="detail.is_public"
                        :true-value="1"
                        :false-value="0"
                        label="Public"
                      ></v-checkbox>
                  </v-col>

                   <v-col class="pt-1 my-auto" md="2" sm="12">
                     <v-checkbox
                        v-model="detail.contacted_today"
                        :true-value="1"
                        :false-value="0"
                        label="Contacted Today"
                      ></v-checkbox>
                  </v-col> -->
                </v-row>
                <v-row class="mb-3">
                  <v-col class="pt-1 my-auto" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500 required mt-0"
                      for="entity"
                    >
                      Entity
                    </label>
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <v-autocomplete
                      hide-details
                      v-model.trim="detail.entity_id"
                      :items="entityList"
                      :rules="[
                        validateRules.required(detail.entity_id, 'Entity'),
                      ]"
                      dense
                      flat
                      filled
                      placeholder="Entity"
                      item-color="cyan"
                      color="cyan"
                      solo
                      item-value="id"
                      item-text="name"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-title
                            v-html="'No Entity(s) Found.'"
                          ></v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col class="pt-1 text-right my-auto" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500"
                      for="expected_close_date"
                      >Expected Close Date</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <DatePicker
                      solo
                      flat
                      :mandatory="false"
                      :nullable="true"
                      placeholder="Expected Close Date"
                      v-model="detail.expected_close_date"
                    ></DatePicker>
                  </v-col>
                </v-row>
                <v-row class="mb-3">
                  <!-- <v-col class="pt-1 my-auto" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500"
                      for="expected_close_date"
                      >Expected Close Date</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <DatePicker
                      solo
                      flat
                      :mandatory="false"
                      :nullable="true"
                      placeholder="Expected Close Date"
                      v-model="detail.expected_close_date"
                    ></DatePicker>
                  </v-col> -->

                  <v-col class="pt-1" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500 mt-0 d-block"
                      for="actual_closed_date"
                      >Actual Closed Date</label
                    >
                  </v-col>
                  <v-col class="pt-1" md="4" sm="12">
                    <DatePicker
                      solo
                      flat
                      :mandatory="false"
                      :nullable="true"
                      placeholder="Actual Closed Date"
                      v-model="detail.actual_closed_date"
                    ></DatePicker>
                  </v-col>
                  <v-col class="pt-1 text-right" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500 mt-0 d-block"
                      for="internal_remark"
                      >Internal Remark</label
                    >
                  </v-col>

                  <v-col class="pt-1" md="4" sm="12">
                    <v-textarea
                      v-model="detail.internal_remark"
                      auto-grow
                      dense
                      filled
                      color="cyan"
                      placeholder="Internal Remark"
                      solo
                      flat
                      row-height="15"
                      v-on:keypress="(e) => manageRemarkLimit(e)"
                      v-on:paste="(e) => onRemarkPaste(e)"
                    ></v-textarea>
                  </v-col>
                  <v-col md="12" class="text-right"
                    >{{
                      detail.internal_remark
                        ? detail.internal_remark.length
                        : 0
                    }}/200</v-col
                  >
                </v-row>

                <!-- <v-row class="mb-3">
                  <v-col class="pt-1" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500"
                      for="internal_remark"
                      >Internal Remark</label
                    >
                  </v-col>

                  <v-col class="pt-1" md="10" sm="12">
                    <v-textarea
                      v-model="detail.internal_remark"
                      auto-grow
                      dense
                      filled
                      color="cyan"
                      placeholder="Internal Remark"
                      solo
                      flat
                      row-height="15"
                      v-on:keypress="(e) => manageRemarkLimit(e)"
                      v-on:paste="(e) => onRemarkPaste(e)"
                    ></v-textarea>
                  </v-col>
                  <v-col md="12" class="text-right"
                    >{{
                      detail.internal_remark
                        ? detail.internal_remark.length
                        : 0
                    }}/200</v-col
                  >
                </v-row> -->

                <v-row class="mb-3">
                  <v-col class="pt-1" md="2" sm="12">
                    <label
                      class="font-size-16 font-weight-500"
                      for="email_reply"
                      >Email Reply(Inquiry Message)</label
                    >
                  </v-col>

                  <v-col class="pt-1" md="10" sm="12">
                    <v-textarea
                      v-model="detail.email_reply"
                      auto-grow
                      dense
                      filled
                      color="cyan"
                      placeholder="Email Reply(Inquiry Message)"
                      solo
                      flat
                      row-height="15"
                      v-on:keypress="(e) => manageReplyLimit(e)"
                      v-on:paste="(e) => onReplyPaste(e)"
                    ></v-textarea>
                  </v-col>
                  <v-col md="12" class="text-right"
                    >{{
                      detail.email_reply ? detail.email_reply.length : 0
                    }}/200</v-col
                  >
                </v-row>

                <v-row class="mb-5">
                  <v-col class="pt-1" md="12" sm="12">
                    <DocumnetList
                      :extensive="false"
                      v-model="detail.attachments"
                      :document-type="docType"
                    >
                    </DocumnetList>
                  </v-col>
                </v-row>
              </v-container>
            </perfect-scrollbar>
          </v-col>
        </v-row>
      </v-layout>
    </v-col>
    <template v-if="false && !isDialog">
      <v-col
        class="custom-sidebar-container grey lighten-3"
        cols="12"
        md="3"
        sm="3"
      >
        <template v-for="(fieldInfo, indx) in fieldDescriptions">
          <div
            v-if="fieldInfo.field == currentActiveField"
            :key="indx"
            class="help-sidebar"
          >
            <div class="help-sidebar-header">
              <h3 v-if="fieldInfo.title" class="section-header-title">
                {{ fieldInfo.title }}
              </h3>
            </div>
            <p v-if="fieldInfo.description" class="help-sidebar-description">
              {{ fieldInfo.description }}
            </p>
            <h5 v-if="fieldInfo.footer" class="help-sidebar-footer-title">
              {{ fieldInfo.footer }}
            </h5>
            <p v-if="fieldInfo.footer_content" class="help-sidebar-footer-text">
              {{ fieldInfo.footer_content }}
            </p>
          </div>
        </template>
      </v-col>
    </template>

    <ManageProductType
      :d-dialog="manageProductType"
      :product_types="productTypeList"
      v-on:close-dialog="manageProductType = false"
      v-on:get-product-types="getOptions"
    ></ManageProductType>

    <ManagePosition
      :d-dialog="managePosition"
      :e_positions="positionList"
      v-on:close-dialog="managePosition = false"
      v-on:get-positions="getOptions"
    ></ManagePosition>
  </v-layout>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import DocumnetList from "@/view/pages/DocumnetList";
import ManageProductType from "@/view/pages/partials/Manage-Product-Type.vue";
import ManagePosition from "@/view/pages/partials/Manage-Position.vue";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CustomerMixin from "@/core/plugins/customer-mixin";
import { GET, QUERY } from "@/core/services/store/request.module";
import FileManagerMixin from "@/core/lib/file-manager/file.manager.mixin";
import PhoneTextField from "@/view/pages/partials/PhoneTextField";
import { SET_ACTIVE_FIELD_DATA } from "@/core/services/store/custom.fields.module.js";
import { mapGetters } from "vuex";
import DatePicker from "@/view/components/DatePicker.vue";

export default {
  name: "contact-details",
  title: "Customer",
  mixins: [CommonMixin, ValidationMixin, CustomerMixin, FileManagerMixin],
  props: {
    lead: {
      type: Object,
      default: function () {
        return {};
      },
    },
    detail: {
      type: Object,
      required: true,
    },

    options: {
      type: Object,
      default: function () {
        return {};
      },
    },
    isDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      groupList: [],
      docType: 20,
      pageLoading: false,
      manageProductType: false,
      managePosition: false,
      entityList: [],
      proposal: 0,
      entity_id: null,
      timeoutLimit: 500,
      timeout: null,
      autocompleteList: new Array(),
      autocompleteLoading: false,
      isFocused: false,
      isFocusedU: false,
      isFocusedN: false,
      isFocusedD: false,
      custom_field_module_id: null,
      productTypeList: [],
      userList: [],
      positionList: [],

      imageLoading: false,
      emailDetails: [
        {
          title: "main",
          value: null,
          type: 1,
          id: null,
        },
      ],
      contactDetails: [
        {
          title: "main",
          value: null,
          type: 2,
          id: null,
        },
        {
          title: "fax",
          value: null,
          type: 2,
          id: null,
        },
      ],

      sourceList: [
        {
          text: "Web Enquiry",
          value: "Web Enquiry",
        },
        {
          text: "Web Chat",
          value: "Web Chat",
        },
        {
          text: "Email Marketer",
          value: "Email Marketer",
        },
        {
          text: "Tele Call",
          value: "Tele Call",
        },
        {
          text: "Google Adwords",
          value: "Google Adwords",
        },
        {
          text: "Fsm/Ams",
          value: "Fsm/Ams",
        },
        {
          text: "Facebook",
          value: "Facebook",
        },
        {
          text: "Referral",
          value: "Referral",
        },
        {
          text: "Intern",
          value: "Intern",
        },
        {
          text: "Canvassing Team",
          value: "Canvassing Team",
        },

        {
          text: "None",
          value: "None",
        },
      ],

      countryList: [
        {
          text: "Singapore",
          value: "singapore",
          country_code: "sg",
        },
        {
          text: "Malaysia",
          value: "malaysia",
          country_code: "my",
        },
        {
          text: "Myanmar",
          value: "myanmar",
          country_code: "mm",
        },
        {
          text: "India",
          value: "india",
          country_code: "in",
        },
        {
          text: "China",
          value: "china",
          country_code: "cn",
        },
        {
          text: "Australia",
          value: "australia",
          country_code: "at",
        },
        {
          text: "American",
          value: "american",
          country_code: "as",
        },
        {
          text: "UK",
          value: "uk",
          country_code: "gb",
        },
        {
          text: "Canada",
          value: "canada",
          country_code: "ca",
        },
      ],

      statusList: [
        {
          text: "Not Contacted",
          value: "Not Contacted",
          color: "grey",
        },
        {
          text: "Follow Up",
          value: "Follow Up",
          color: "yellow",
        },
        {
          text: "Meeting",
          value: "Meeting",
          color: "blue",
        },
        {
          text: "Converted to Customer",
          value: "Converted to Customer",
          color: "orange",
        },
        {
          text: "Accepted",
          value: "Accepted",
          color: "green",
        },
        {
          text: "Rejected",
          value: "Rejected",
          color: "red",
        },
      ],

      fieldDescriptions: [
        {
          field: "product_type",
          title: "Product Type",
          description:
            "Select if this item is a physical good or a service you're offering.",
          footer: "Note",
          footer_content:
            "Once you include this items in a transaction, you cannot change its type.",
        },
      ],
    };
  },
  watch: {
    lead: {
      handler(val) {
        if (val && val.entity_id) {
          this.detail.entity_id = val.entity_id;
        }
      },
      deep: true,
      immediate: true,
    },
    detail: {
      handler(param) {
        this.$emit("update:detail", { ...param });
      },
      deep: true,
    },
  },
  methods: {
    validateAmount() {
      let value = String(this.detail.amount);
      let [integerPart, decimalPart] = value.split(".");

      if (integerPart.length > 10) {
        this.detail.amount = decimalPart
          ? `${integerPart.slice(0, 10)}.${decimalPart}`
          : integerPart.slice(0, 10);
      } else {
        this.detail.amount = decimalPart
          ? `${integerPart}.${decimalPart}`
          : integerPart;
      }
    },

    onRemarkPaste(e) {
      let coppied = e.clipboardData.getData("Text");
      let preVal = this.detail.internal_remark;
      let finalval = String(preVal) + String(coppied);
      if (Number(finalval.length) > 199) {
        let trimValue = finalval.substring(0, 200);
        this.detail.internal_remark = trimValue;
        e.preventDefault();
      }
    },

    manageRemarkLimit(e) {
      if (
        this.detail.internal_remark &&
        this.detail.internal_remark.length > 199
      ) {
        e.preventDefault();
      }
    },

    onReplyPaste(e) {
      let coppied = e.clipboardData.getData("Text");
      let preVal = this.detail.email_reply;
      let finalval = String(preVal) + String(coppied);
      if (Number(finalval.length) > 199) {
        let trimValue = finalval.substring(0, 200);
        this.detail.email_reply = trimValue;
        e.preventDefault();
      }
    },

    manageReplyLimit(e) {
      if (this.detail.email_reply && this.detail.email_reply.length > 199) {
        e.preventDefault();
      }
    },

    openProductTypeDialog() {
      this.manageProductType = true;
      this.getOptions();
    },

    openPositionDialog() {
      this.managePosition = true;
      this.getOptions();
    },

    getOptions() {
      this.pageLoading = true;
      this.$store
        .dispatch(QUERY, {
          url: "lead/options",
        })
        .then(({ data }) => {
          if (data.product_types) {
            this.productTypeList = data.product_types;
          }

          if (data.users) {
            this.userList = data.users;
          }

          if (data.positions) {
            this.positionList = data.positions;
          }

          if (data.entities) {
            this.entityList = data.entities;
          }
        })
        .catch((error) => {
          this.logError(error);
          this.goBack();
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },

    clearAddress() {
      const _this = this;
      _this.detail.postal_code = null;
      _this.detail.address_line_1 = null;
      _this.detail.address_line_2 = null;
      _this.detail.unit_no = null;
    },

    onPaste(e) {
      let coppied = e.clipboardData.getData("Text");
      let preVal = this.detail.customer_remark;
      let finalval = String(preVal) + String(coppied);
      if (Number(finalval.length) > 199) {
        let trimValue = finalval.substring(0, 200);
        this.detail.customer_remark = trimValue;
        e.preventDefault();
      }
    },

    updateDetails() {
      const _this = this;
      _this.detail.details = [];
      for (let i = 0; i < _this.emailDetails.length; i++) {
        if (_this.emailDetails[i]) {
          delete _this.emailDetails[i].default;
          _this.detail.details.push(_this.emailDetails[i]);
        }
      }
      for (let z = 0; z < _this.contactDetails.length; z++) {
        if (_this.contactDetails[z]) {
          delete _this.contactDetails[z].default;
          _this.detail.details.push(_this.contactDetails[z]);
        }
      }
    },

    getGroupList() {
      const _this = this;
      _this.$store
        .dispatch(GET, {
          url: "customer/group-list",
        })
        .then(({ data }) => {
          _this.groupList = data.group_list;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },

    editDetails() {
      const _this = this;

      _this.defaultPerson = _this.getDefaultPerson(_this.customer);
      _this.emailDetails = _this.getEmailDetails(_this.customer);
      _this.contactDetails = _this.getPhoneDetails(_this.customer);

      const faxContactDetails = _this.lodash.filter(_this.contactDetails, {
        title: "fax",
      });

      const mainContactDetails = _this.lodash.filter(_this.contactDetails, {
        title: "main",
      });

      if (_this.lodash.isEmpty(mainContactDetails)) {
        _this.contactDetails.push({
          title: "main",
          value: null,
          type: 2,
          id: null,
        });
      }

      if (_this.lodash.isEmpty(faxContactDetails)) {
        _this.contactDetails.push({
          title: "fax",
          value: null,
          type: 2,
          id: null,
        });
      }
      _this.detail.id = _this.customer.id;
      _this.detail.salutation = _this.defaultPerson.title;
      _this.detail.first_name = _this.defaultPerson.first_name;
      _this.detail.last_name = _this.defaultPerson.last_name;

      _this.detail.primary = _this.customer.primary;

      _this.detail.company_name = _this.customer.company_name;
      _this.detail.uen = _this.customer.uen;
      _this.detail.display_name = _this.customer.display_name;
      _this.detail.customer_remark = _this.customer.customer_remark;
      _this.detail.entity_id = _this.customer.entity_id;
      _this.detail.group_id = _this.customer.group_id;
      _this.detail.phone = _this.customer.phone;
      _this.detail.website = _this.customer.website;
      _this.detail.unit_no = _this.customer.unit_no;
      _this.detail.address_line_1 = _this.customer.address_line_1;
      _this.detail.address_line_2 = _this.customer.address_line_2;
      _this.detail.category = _this.customer.category;
      _this.detail.category_color = _this.customer.category_color;
      _this.detail.tags = _this.customer.tags;
      _this.detail.company_number = _this.customer.company_number;
      _this.detail.company_fax = _this.customer.company_fax;
      _this.detail.company_email = _this.customer.company_email;
      _this.detail.company_email = _this.customer.company_email;
      _this.detail.company_email = _this.customer.company_email;
      _this.detail.company_email = _this.customer.company_email;
      _this.detail.company_type = _this.customer.company_type;
      _this.detail.postal_code = _this.customer.postal_code;
      _this.detail.country = _this.customer.country;
      _this.detail.security_code = _this.customer.security_code;
      _this.detail.state = _this.customer.state;
      _this.detail.city = _this.customer.city;
      _this.detail.profile_logo = _this.customer.profile_logo;
      _this.detail.retention_period = _this.customer.retention_period;
      _this.detail.deletion_period = _this.customer.deletion_period;
      _this.detail.period = _this.customer.period;
      _this.detail.automatic_deletion_period =
        _this.customer.automatic_deletion_period;
      //sap detail
      _this.detail.sap_customer_no = _this.customer.sap_customer_no
        ? _this.customer.sap_customer_no
        : null;
      _this.detail.cust_vend_ref_no = _this.customer.cust_vend_ref_no
        ? _this.customer.cust_vend_ref_no
        : null;

      _this.$store.commit(SET_ACTIVE_FIELD_DATA, _this.customer.custom_fields);
    },
  },
  mounted() {
    const _this = this;
    _this.getGroupList();
    this.getOptions();

    if (this.currentUser.role == 5) {
      this.detail.assign_to = this.currentUser?.id;
    }
  },
  components: {
    PhoneTextField,
    ManageProductType,
    DatePicker,
    ManagePosition,
    DocumnetList,
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
};
</script>
